import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from '@xstate/react';
import {
  Currency,
  formatBillingInterval,
  formatCurrency,
} from '@chargify/formatters';
import PlanRadio from '../../components/PlanRadio';
import { ChangePlanInterpreter } from '../../machines/changePlan/types';
import { Wrapper } from './ChangePlan.styles';
import { changePlanSelectors } from '../../machines/changePlan';

type Props = {
  changePlanService: ChangePlanInterpreter;
  currentPlanId: number;
  currency: Currency;
};
const ChangePlanContainer = ({
  currentPlanId,
  currency,
  changePlanService,
}: Props) => {
  const { t } = useTranslation(['common']);
  const products = useSelector(
    changePlanService,
    changePlanSelectors.getProducts
  );
  const selectedPlan = useSelector(
    changePlanService,
    changePlanSelectors.getSelectedPlan
  );
  const onPlanChange = (planId: number) => {
    changePlanService.send({ type: 'SELECT_PLAN', planId });
  };
  return (
    <Wrapper>
      {products?.map(({ priceInCents, name, id, interval, intervalUnit }) => (
        <PlanRadio
          key={id}
          id={id}
          name={name}
          price={formatCurrency(currency, priceInCents)}
          interval={interval}
          intervalUnit={formatBillingInterval(interval, intervalUnit, t)}
          selected={selectedPlan === id}
          isCurrentPlan={id === currentPlanId}
          onClick={onPlanChange}
        />
      ))}
    </Wrapper>
  );
};
export default ChangePlanContainer;
